import HttpFactory from '../HttpFactory'
import type IBasicObjectResponse from '../interfaces/IBasicObjectResponse'
import type SearchParams from '../../../types/search/SearchParams'

class SearchModule extends HttpFactory {
  private RESOURCE = 'services/search'

  async search (searchParams: SearchParams) {
    return await this.callUseFetch<IBasicObjectResponse>(
      'POST',
      `${this.RESOURCE}`,
      {
        params: searchParams
      },
      {},
      {
        watch: false
      }
    )
  }

  async searchFromClient (searchParams: SearchParams) {
    return await this.callFetch<IBasicObjectResponse>(
      'POST',
      `${this.RESOURCE}`,
      {
        params: searchParams
      }
    )
  }
}

export default SearchModule
